import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';

import App from './App';
import ToasterContainer from './ToasterContainer';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';

const tagManagerArgs = {
  gtmId: 'GTM-M94V7ZL',
};

TagManager.initialize(tagManagerArgs);

ReactDOM.createRoot(document.getElementById('toaster') as HTMLElement).render(
  <ToasterContainer />
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
